<template>
	<div class="shopListItemContainer" @click="goToShop">
		<div class="cover" :class="{ over: store.status == 0, waiting: store.status == 2, soldout: store.status == 3 }">
			<img :src="store.logo" alt="" class="logo" />
			<div class="top" v-if="store.is_top == true">推荐</div>
			<div class="tip" v-if="nearest">距离最近</div>
		</div>
		<div class="info">
			<div class="header">
				<div class="name">{{ store.title }}</div>
				<div class="label">
					<template v-if="false">
						(需提前一天预订)
					</template>
				</div>
				<div class="distance">{{ store.distance }}</div>
			</div>
			<!-- 星级月售暂时隐藏 -->
			<div class="desc">
				<Star-List :stars="store.start" v-if="false" />
				<div class="saleNum" v-if="false">月售 {{ store.sale }}</div>
				<div style="flex:1;">&nbsp;</div>
				<!-- <div
				 class="tip"
				 v-if="$root.type=='package' && store.personal != 0"
				>{{(store.personal ==1?'可':'仅')}}到店自取</div> -->
			</div>
			<div class="shortTitle">{{ store.slogan }}</div>
			<div class="activityContainer" v-if="store.discount.length > 0" :class="{ showMore: showMoreActivity }">
				<div class="activityList">
					<div
						class="activityItem"
						v-for="(discount, index) in store.discount"
						:key="index"
						:class="{ discount: discount.type == '折', subtract: discount.type == '减' }"
					>
						{{ discount.title }}
					</div>
				</div>
				<div class="activityTotal" v-if="store.discount.length > 1" @click.stop="showMoreActivity = !showMoreActivity">
					<span>{{ store.discount.length }}个活动</span>
					<img src="@/assets/images/index/arrow_down_white.png" alt="" />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import StarList from '@/components/StarList';
export default {
	props: {
		store: {
			type: Object,
			required: true
		},
		nearest: {
			type: Boolean,
			required: true,
			default: false
		},
		nopay: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			showMoreActivity: false,
			showUnpay: true,
			showstore: {}
		};
	},
	updated() {
		// this.showstore = this.$props.store;
	},
	methods: {
		goToShop() {
			window.location.href = `./shop.html?store_id=${this.store.id}`;
		}
	},
	components: {
		StarList
	}
};
</script>

<style lang="scss" scoped>
@import '~@/scss/libs.scss';

.shopListItemContainer {
	width: 100%;
	@include dis-flex(false, space-between);
	position: relative;
	.cover {
		@include square(150);
		position: relative;
		border-radius: px2rem(20);
		overflow: hidden;
		margin: px2rem(30) px2rem(20) px2rem(30) 0;
		flex: 0 0 px2rem(150);
		img {
			@include square(100%);
		}
		.top {
			@include pos-a($left: 0, $top: 0);
			padding: px2rem(6);
			background: $shallowRed;
			color: white;
			border-bottom-right-radius: px2rem(20);
		}
		.tip {
			position: absolute;
			bottom: 0;
			left: 0;
			@include square(100%, 24);
			color: #ffffff;
			font-size: px2rem(18);
			line-height: px2rem(24);
			background-color: #f7cd0f;
			text-align: center;
		}
		&.over,
		&.waiting,
		&.soldout {
			&::before {
				content: '';
				display: block;
				@include mask-container;
			}
			&::after {
				@extend %abs-center;
				display: block;
				font-size: px2rem(28);
				color: #ffffff;
				white-space: nowrap;
			}
		}
		&.over::after {
			content: '休息中';
		}
		&.waiting::after {
			content: '准备中';
		}
		&.soldout::after {
			content: '已售罄';
		}
	}
	.info {
		flex: 1;
		padding: px2rem(30) 0;
		border-bottom: px2rem(1) dotted #e4e4e4;
		transition: all 0.5s;
		.header {
			width: 100%;
			@include dis-flex(flex-end);
			.name {
				font-size: px2rem(30);
				color: #303234;
			}
			.label {
				font-size: px2rem(24);
				color: #a6a6a6;
				flex: 1 0 auto;
			}
			.distance {
				font-size: px2rem(26);
				color: #303234;
			}
		}
		.desc {
			width: 100%;
			margin-top: px2rem(14);
			@include dis-flex;
			font-size: px2rem(20);
			line-height: 1;
			.saleNum {
				font-size: px2rem(20);
				color: #a6a6a6;
				margin-left: px2rem(20);
				flex: 1 0 auto;
			}
			.tip {
				padding: px2rem(2) px2rem(10);
				border: px2rem(1) solid #73c6c8;
				color: #73c6c8;
				font-size: px2rem(20);
			}
		}
		.shortTitle {
			width: 100%;
			font-size: px2rem(22);
			line-height: 1.4;
			color: #a6a6a6;
			margin-top: px2rem(14);
			word-break: break-all;
		}
		.activityContainer {
			width: 100%;
			@include dis-flex(flex-start, space-between);
			margin-top: px2rem(14);
			font-size: px2rem(22);
			line-height: 1;
			.activityList {
				flex: 1 0 auto;
				height: px2rem(23);
				// padding-top:px2rem(2);
				overflow: hidden;
				.activityItem {
					@include dis-flex;
					width: 100%;
					color: #545b5b;
					line-height: px2rem(22);
					align-items: flex-start;
					// padding:px2rem(6) 0;
					&:not(:first-child) {
						margin-top: px2rem(14);
					}
					&::before {
						@include square(22);
						color: #ffffff;
						// font-size: px2rem(18);
						// align-items: center;
						// line-height: px2rem(22);
						// padding:px2rem(2) px2rem(4);
						display: block;
						margin-right: px2rem(10);
						text-align: center;
					}
					&.discount::before {
						// background-color: #fe6f41;
						background: url('~@/assets/images/zhe.png') no-repeat;
						background-size: 100%;
						content: '';
					}
					&.subtract::before {
						background: url('~@/assets/images/minus.png') no-repeat;
						background-size: 100%;
						// background-color: #e32351;
						content: '';
					}
				}
			}
			.activityTotal {
				@include dis-flex(center);
				font-size: px2rem(18);
				line-height: px2rem(22);
				color: #a6a6a6;
				img {
					width: px2rem(16);
					margin-left: px2rem(10);
					display: block;
					transition: all 0.5s;
				}
			}
			&.showMore {
				.activityList {
					height: auto;
					overflow: visible;
				}
				.activityTotal img {
					transform: rotate(180deg);
					transform-origin: center center;
				}
			}
		}
	}
}
</style>
